// libraries.
import { useMemo } from 'react';

// interfaces.
import { IOrchestratorPricingCommittee } from '../interfaces/interfaces';

interface DiffPrice {
  comision?: {
    precio_maximo?: number;
    precio_intermedio?: number;
    precio_base?: number;
    precio_minimo?: number;
    ab_test?: string;
  };
  compraventa?: {
    precio_maximo?: number;
    precio_intermedio?: number;
    precio_base?: number;
    precio_minimo?: number;
    ab_test?: string;
  };
}

interface DetailWithDiffPrice {
  diff_price?: DiffPrice;
  [key: string]: any;
}

interface MaxPriceResult {
  precioMaximo: number | null;
  precioMaximoComision: number | null;
  found: boolean;
}

export const useMaxPrice = (
  orchestrator: IOrchestratorPricingCommittee | undefined
): MaxPriceResult => {
  return useMemo(() => {
    if (!orchestrator?.workflow_steps) {
      return { precioMaximo: null, precioMaximoComision: null, found: false };
    }

    // Buscar el step "idm ensamble de precio"
    const priceStep = orchestrator.workflow_steps.find(
      step => step.name === 'idm ensamble de precio'
    );

    if (!priceStep || !priceStep.responses || priceStep.responses.length === 0) {
      return { precioMaximo: null, precioMaximoComision: null, found: false };
    }

    // Obtener el último response del array
    const lastResponse = priceStep.responses[priceStep.responses.length - 1];

    // Validar que el último response tenga status COMPLETED
    if (lastResponse.status !== 'COMPLETED' || !lastResponse.detail) {
      return { precioMaximo: null, precioMaximoComision: null, found: false };
    }

    // Extraer diff_price del detail
    const detail = lastResponse.detail as DetailWithDiffPrice;
    const diffPrice = detail.diff_price;

    if (!diffPrice) {
      return { precioMaximo: null, precioMaximoComision: null, found: false };
    }

    const precioMaximo = diffPrice.compraventa?.precio_maximo ?? null;
    const precioMaximoComision = diffPrice.comision?.precio_maximo ?? null;

    return {
      precioMaximo,
      precioMaximoComision,
      found: precioMaximo !== null || precioMaximoComision !== null,
    };
  }, [orchestrator]);
};
